import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Create your Instana API Token`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open Instana from the DemoUI - Tab `}<inlineCode parentName="p">{`IBM AIOps`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Login with:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`User: `}<inlineCode parentName="li">{`admin@instana.local`}</inlineCode></li>
          <li parentName="ul">{`Password: `}<inlineCode parentName="li">{`P4ssw0rd!`}</inlineCode></li>
        </ul>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_01.png",
          "alt": "slack1"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`Settings`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_02.png",
          "alt": "slack1"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`API Tokens`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_03.png",
          "alt": "slack1"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Add API Token`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_04.png",
          "alt": "slack1"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Give your API Token a unique name `}</p>
        <img parentName="li" {...{
          "src": "./../images/instana/instana_05.png",
          "alt": "slack1"
        }}></img>
        <p parentName="li">{`You may add team members to your new Slack workspace or skip this step.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the Eye Icon twice to copy the token. `}<strong parentName="p">{`SAVE IT`}</strong>{` somewhere save, we’ll need it in the next step.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save`}</inlineCode></p>
      </li>
    </ol>
    <p>{`At this point you have created your own Ìnstana API Token.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      